import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

export default class FirebaseInitializer {
  constructor(user, dispatch) {
    if (!user || !dispatch) throw new Error('User and dispatch are required');
    this.firebaseConfig = {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID,
    };
    this.vapidKey = process.env.VUE_APP_FIREBASE_VAPID_KEY;
    this.app = null;
    this.messaging = null;
    this.user = user;
    this.storeDispatch = dispatch;
  }

  async init() {
    try {
      this.app = initializeApp(this.firebaseConfig);
    } catch (e) {
      console.log(e);
    }
    if (!this.app) return null;
    this.messaging = getMessaging(this.app);

    let currentToken;
    try {
      await Notification.requestPermission();
      const permission = await Notification.permission;
      if (permission === 'granted') {
        currentToken = await getToken(this.messaging, this.vapidKey);
        console.log(currentToken ? `Token received: ${currentToken}` : 'Token not received');
        onMessage(this.messaging, (payload) => {
          console.log('Message received.', payload);
          if (payload && payload.data) {
            this.receiveMessage(payload);
          }
        });
      } else {
        console.log('Permission denied for notifications');
      }
    } catch (error) {
      console.error('Error initializing Firebase:', error);
    }
    return currentToken;
  }

  receiveMessage(payload) {
    if (this.user && this.storeDispatch) {
      const parsedData = {};
      if (payload.data) {
        Object.keys(payload.data).forEach((key) => {
          try {
            parsedData[key] = JSON.parse(payload.data[key]);
          } catch {
            parsedData[key] = payload.data[key] || null;
          }
        });
      }
      const type = parsedData.type;
      const pushData = parsedData.data || {};

      // request関連（配車確定/キャンセル）
      if (type === 'request') {
        // modalName特定
        const modalNames = {
          created: 'dispatch-request',
          canceled: 'request-canceled',
        };
        const modalName = modalNames[pushData.status];
        if (!modalName) return;

        const args = {
          name: modalName,
          link: modalName === 'dispatch-request' ? '/request/' : null,
          autoClose: true,
        };
        this.storeDispatch('user/update', null, { root: true });
        this.setNotice(args);
      }

      if (type === 'dispatched') {
        const args = {
          name: 'reservation-confirmed',
          link: '/order/',
          autoClose: true,
        };
        this.storeDispatch('user/update', null, { root: true });
        this.setNotice(args);
      }

      if (type === 'canceled') {
        const args = {
          name: 'reservation-canceled',
          link: '/order/',
          autoClose: true,
        };
        this.storeDispatch('user/update', null, { root: true });
        this.setNotice(args);
      }

      if (type === 'update') this.storeDispatch('user/update', null, { root: true });
      if (type === 'message') {
        this.storeDispatch('user/update', null, { root: true });
        const args = {
          name: 'ReceiveMessage',
          link: `/order/?code=${parsedData.data.code}`,
          autoClose: true,
          data: {
            text: parsedData.data.message,
          },
        };
        this.setNotice(args);
      }
    }
  }

  setNotice(args) {
    this.storeDispatch('notice/setNotice', args, { root: true });
  }
}
